// src/components/tool-calls/toolCallFormat.ts
// Pure formatting helpers shared by the tool-call drawers. Kept out of
// toolCallView.tsx so that file exports only components (react-refresh).

export function formatBytes(b: number): string {
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
  return `${(b / 1024 / 1024).toFixed(2)} MB`;
}

export function formatTimestamp(iso: string): string {
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}

export function getErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'response' in err) {
    const data = (err as { response?: { data?: { error?: unknown } } }).response?.data?.error;
    if (typeof data === 'string') return data;
  }
  if (err instanceof Error) return err.message;
  return 'Unknown error';
}
